import { render, staticRenderFns } from "./UnboxHeaderBox.vue?vue&type=template&id=bfe7fe06&scoped=true"
import script from "./UnboxHeaderBox.vue?vue&type=script&lang=js"
export * from "./UnboxHeaderBox.vue?vue&type=script&lang=js"
import style0 from "./UnboxHeaderBox.vue?vue&type=style&index=0&id=bfe7fe06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe7fe06",
  null
  
)

export default component.exports